import { writable } from "svelte/store";

//types
import type { DwollaAcknowledgment } from "@shared/types/DwollaAcknowledgment";

export type DwollaAcknowledgmentsRequest = {
  dwollaAcknowledgments: DwollaAcknowledgment[];
  loaded: boolean;
  failed: boolean;
};

export const initialDwollaAcknowledgmentsState: DwollaAcknowledgmentsRequest = {
  loaded: false,
  failed: false,
  dwollaAcknowledgments: [],
};

export const dwollaAcknowledgmentsStore = writable<DwollaAcknowledgmentsRequest>(
  initialDwollaAcknowledgmentsState,
);
